// This one is a little tricky!
// needs to be included on goal pages that are gmail for settings reasons

import "../autod/gmail"